import Vue from"vue";export const typedModal=()=>Vue.extend();